import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";

export const useResendInvite = (id) => {
  const mutationFn = () => client.users.resendInvite(id);

  return useMutation({
    mutationFn,
  });
};
